import React, { useEffect, useState } from 'react';
import JobFormPage from '../JobFormPage';
import { Text } from 'library';
import JobTitleInput from './JobTitleInput';
import JobDescriptionInput from './JobDescriptionInput';
import { FieldStates } from '../../FormTypes';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { client, consoleLogInDev } from 'shared';
import FormField from '../../FormField';
import { JobDetail } from 'models';
import JobDetailInput from './JobDetailInput';
import { JobFormFields } from 'parent-portal/forms/JobRequestTypes';

export default function BusinessJobHeadlinePage({ fieldStates }: { fieldStates: FieldStates<JobFormFields> }) {
    const [isValid, setIsValid] = useState(false);
    const { goToNext } = useJobFormContext();
    const [details, setDetails] = useState<JobDetail[]>([]);
    const { headline, comments, jobDetails } = fieldStates;

    const getJobDetails = () => {
        client('api/job-detail/').then(setDetails).catch(consoleLogInDev);
    };

    useEffect(getJobDetails, []);

    useEffect(() => {
        setIsValid(headline.value !== '' && comments.value !== '');
    }, [headline, comments]);

    return (
        <JobFormPage
            title="Now, tell us a few details."
            subtitle="We recommend creating one job for each need you have. That will help the best fit worker be matched to the specific job they are fit for."
            onNextClicked={() => goToNext()}
            nextDisabled={!isValid}
        >
            <div style={{ marginTop: 30 }} />
            <JobTitleInput title={headline} business />
            {details.map((detail) => (
                <FormField title={detail.name} key={detail.id}>
                    <JobDetailInput detail={detail} jobDetails={jobDetails} />
                </FormField>
            ))}
            <JobDescriptionInput description={comments} business />
            <Text variant="caption">
                Only include job responsibilities here. We will ask you the rest of the job’s info on the next few
                screens!
            </Text>
        </JobFormPage>
    );
}
